import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

function AccessDenied() {
  const location = useLocation();
  const navigate = useNavigate();
  const error = location.state?.error || 'Acesso restrito. Entre em contato com a empresa de consultoria.';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100">
      <Card className="w-full max-w-md p-8 shadow-lg">
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-red-100 rounded-full mx-auto mb-4 flex items-center justify-center">
            <svg className="w-10 h-10 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">Acesso Negado</h1>
        </div>

        <Alert variant="destructive" className="mb-6">
          <AlertDescription>{error}</AlertDescription>
        </Alert>

        <div className="space-y-4">
          <p className="text-sm text-gray-600 text-center">
            Se você acredita que isso é um erro, entre em contato com o administrador do sistema.
          </p>

          <Button
            onClick={() => navigate('/login')}
            className="w-full bg-emerald-800 hover:bg-emerald-900"
          >
            Voltar para Login
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default AccessDenied;